/* unplugin-vue-components disabled */import { render } from "./additional-details.vue?vue&type=template&id=e7ba85b6"
import script from "./additional-details.vue?vue&type=script&lang=js"
export * from "./additional-details.vue?vue&type=script&lang=js"

import "./additional-details.vue?vue&type=style&index=0&id=e7ba85b6&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__